import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface MoneyBillIconProps {
  className?: string;
}

export const MoneyBillIcon = ({ className = '' }: MoneyBillIconProps) => {
  return <FontAwesomeIcon icon={faMoneyBill} className={className} />;
};
